const Pagination = () => {
  $("#pagination").on("click", "a", function (e) {
    e.preventDefault();
    $(this).remove();
    const url = $(this).attr("href");
    
    $("#ajax-loader").load(url + " #ajax-posts>*", () => {
      //history.pushState({}, "", url);
      $("#ajax-posts").append($("#ajax-loader > *"));
    });
    $("#pagination").load($(this).attr("href") + " #pagination>*");
  });
};

export default Pagination;
